
  import { Component, Watch } from 'vue-property-decorator'
  import GTextarea from '@/components/core/input/GTextarea.vue'
  import PTitle from '@/components/config/PTitle.vue'
  import { GenioView } from './GenioView'
  import GCostField from '@/components/core/input/GCostField.vue'
  import PSubtitle from '../PSubtitle.vue'

  @Component({
    components: { PTitle, GTextarea, GCostField, PSubtitle },
  })
  export default class ConfigPayment extends GenioView {
    valid = true

    financialAccountsSpent= []
    financialAccountsIncome= []

    formData = {
      quotas: {
        credit_card: {
          maxQuotas: 60,
          quotaExcluded: [3],
        },
        bill_exchange: {
          maxQuotas: 3,
        },
      },
      renewal: {
        id_financial_account_spent: 1,
        id_financial_account_income: 3,
      },
      consignment: {
        id_financial_account_income: [3],
      },
    }

    async mounted () {
      const accounts = await this.fetchData({
        query: { name: 'find', model: 'FinancialAccount' },
        force: true,
      })
      this.financialAccountsSpent = accounts.filter((account: any) => account.financialCategory === 'spent')
      this.financialAccountsIncome = accounts.filter((account: any) => account.financialCategory === 'income')
    }

    async save () {
      if (!this.$refs.form.validate()) {
        await this.setFieldError()
        return
      }

      const fields = {
        id: this.process.id,
        config: {
          ...this.process.config,
          quotas: {
            credit_card: {
              ...this.process.config.quotas.credit_card,
              maxQuotas: parseInt(this.formData.quotas.credit_card.maxQuotas.toString()),
              quotaExcluded: this.formData.quotas.credit_card.quotaExcluded,
            },
            bill_exchange: {
              ...this.process.config.quotas.bill_exchange,
              maxQuotas: parseInt(this.formData.quotas.bill_exchange.maxQuotas.toString()),
            },
          },
          renewal: this.formData.renewal,
          consignment: this.formData.consignment,
        },
      }

      await this.updateProcess(fields)
      this.$emit('update')
    }

    @Watch('process', { immediate: true, deep: true })
    onConfigChange (newValue: any) {
      if (newValue?.config) {
        this.formData = {
          quotas: newValue.config.quotas || this.formData.quotas,
          renewal: newValue.config.renewal || this.formData.renewal,
          consignment: newValue.config.consignment || this.formData.consignment,
        }
      }
    }
  }
